import { marked } from 'marked';
import markedKatex from 'marked-katex-extension';
import 'katex/dist/katex.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

// 启用数学公式渲染插件 (支持 $\alpha$、$\mu$ 等行内/块级 LaTeX 公式)
marked.use(
  markedKatex({
    throwOnError: false,
    nonStandard: true
  })
);

// 配置 marked
const markedOptions: any = {
  renderer: new marked.Renderer(),
  highlight: function (code: string, lang?: string) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(code, { language: lang }).value;
      } catch (err) {
        console.error('Highlight error:', err);
      }
    }
    try {
      return hljs.highlightAuto(code).value;
    } catch (err) {
      console.error('Highlight auto error:', err);
      return code;
    }
  },
  pedantic: false,
  gfm: true,
  breaks: true,
  sanitize: false,
  smartLists: true,
  smartypants: false,
  xhtml: false
};
(marked as any).setOptions(markedOptions);

/**
 * 预处理：表格分隔行之后若出现多行仅由 --- 或 ___ 组成的占位符，
 * 在 Markdown 中会变成水平线(hr)，此处改为空行避免误渲染（如 AI 用 --- 占位因子载荷矩阵表格内容）
 */
function stripTablePlaceholderLines(text: string): string {
  const tableSep = /^\|[\s\-:]+\|/;
  const onlyDashes = /^[-_]{3,}$/;
  const lines = text.split('\n');
  let afterTableSep = false;
  const out: string[] = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (tableSep.test(line.trim())) {
      afterTableSep = true;
      out.push(line);
      continue;
    }
    if (afterTableSep && onlyDashes.test(line.trim())) {
      out.push('');
      continue;
    }
    afterTableSep = false;
    out.push(line);
  }
  return out.join('\n');
}

/**
 * Markdown 渲染函数（使用 marked 库）
 * 支持完整的 Markdown 语法和代码高亮
 */
export function formatMarkdown(text?: string): string {
  if (!text) return '';
  const normalized = stripTablePlaceholderLines(text);
  try {
    let html = marked.parse(normalized) as string;
    html = html.replace(/<a (?=href=)/gi, '<a target="_blank" rel="noopener noreferrer" ');
    return html;
  } catch (error) {
    console.error('Markdown parse error:', error);
    return normalized
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br>');
  }
}

export default formatMarkdown;
